import React from 'react'
import GridDefaultActionButton from './GridDefaultActionButton'
import Theme from 'core/themes/model'
import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles<Theme>((theme) => ({
  dropdownAction: {
    background: theme.components.dropdown.background,
    border: 'none',
    '& .button-text': {
      color: theme.components.dropdown.color,
      justifyContent: 'start',
    },
  },
}))

export default function GridDefaultDropdownActionButton(props) {
  const classes = useStyles()
  return <GridDefaultActionButton {...props} className={classes.dropdownAction} />
}
